import Select from "react-select";
type DropdownProps<T> = {
  source: T[];
  value: string | number | undefined | null;
  onChange: (value: string | number) => void;
  getLabel: (item: T) => string;
  getValue: (item: T) => string | number;
  className?: string;
  searchable?: boolean;
  disabled?: boolean;
};

export function Dropdown<T>({
  source,
  value,
  onChange,
  getLabel,
  getValue,
  className = "",
  searchable,
  disabled
}: DropdownProps<T>) {
  const options = source?.map((item) => ({
    label: getLabel(item),
    value: getValue(item)
  }));
  const selected = options?.find(opt => opt.value === value) ?? null;

  return (
    <Select
      className={className}
      options={options}
      isSearchable={searchable ?? false}
      value={selected}
      isDisabled={disabled}
      placeholder="Select..."
      onChange={(selected) => {
        if (selected) onChange(selected.value);
      }}
    />
  );
}
